<script lang="ts">
    import { Avatar } from "@skeletonlabs/skeleton";

    import { supabase } from "$lib/supabase";
    import { onMount } from "svelte";
    import { user_avatars } from "$lib/stores";

    export let user_id;
    export let user_name;
    export let size = "5";

    function getInitials(name: string): string {
        if (!name) {
            return "";
        }
        if (name.trim().split(" ").length >= 2) {
            return name.split(" ")[0][0] + name.split(" ")[1][0];
        } else {
            return name[0];
        }
    }

    const initials = getInitials(user_name);

    onMount(async () => {
        if (!$user_avatars[user_id]) {
            const { data, error } = await supabase.storage.from("avatars").download(user_id + "/" + user_id);

            if (error) {
                $user_avatars[user_id] = { url: undefined, img: undefined };
            } else {
                $user_avatars[user_id] = { url: URL.createObjectURL(data), img: data };
            }
        }
    });
</script>

{#if !$user_avatars[user_id]?.url}
    <Avatar {initials} width="w-{size}" background="bg-indigo-100" fill="fill-indigo-500" />
{:else}
    <Avatar src={$user_avatars[user_id].url} width="w-{size}" />
{/if}
